import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { Progress } from "../../../styles/styles";
import "./style.css";

function ListCeCategoria(props) {
	const [idContaTipo, setIdContaTipo] = useState(0);
	const [nome, setNome] = useState("");
	const [percentual, setPercentual] = useState(0);
	const [valor, setValor] = useState(0);
	const [total, setTotal] = useState(0);

	return (
		<>
			{props.loading ? (
				<div className="loading text-center h-100 m-5">
					<div>
						<span className="spinner-grow spinner-grow-sm text-primary me-2" role="status"></span>
						<span className="text-primary">Buscando Dados...</span>
					</div>
				</div>
			) : (
				<div className="table-ce table-responsive p-2">
					{/* <h2 className="mt-4">Movimentação por Categoria</h2> */}
					<h6 className="mt-2 text-secondary">Receitas por Categoria</h6>
					{/* <table className="table table-striped mt-3"> */}
					<table className="table mt-3">
						<thead>
							<tr className="tr-ce">
								<th scope="col">Nome</th>
								<th scope="col">Valor</th>
								<th scope="col">Percentual</th>
							</tr>
						</thead>

						<tbody>
							{props.listaContaEntrada.map((contaSaida, i) => {
								return (
									<tr key={i}>
										<td className="col-5">
											<small>{contaSaida.nome}</small>
										</td>
										<td className="col-4">
											<small>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(contaSaida.valor)}</small>
										</td>
										<td className="col-3">
											<Progress width={contaSaida.percentual / 2 + contaSaida.percentual} color="green">
												<small>{contaSaida.percentual}%</small>
												<div className="progressListBackground">
													<div className="progressList"></div>
												</div>
											</Progress>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			)}
		</>
	);
}

export default ListCeCategoria;
